<template>
  <video-player v-if="showPlayer" :sources="sources"></video-player>
  <div v-else class="progress-wrapper is-flex" qa="video-upload-progress">
    <div>
      {{$t('videoInfo.waiting')}}...
      <br>
      {{ $t(`videoInfo.${videoStatus}`) }} {{ videoProgress }}%
    </div>
  </div>
</template>

<script>
import VideoPlayer from './video-player'

export default {
  components: {
    VideoPlayer
  },
  props: ['attachment'],
  mounted: function () {
    if (!this.videoProcessed) {
      this.$store.dispatch('checkVideoProcessStatus', { transactionId: this.metadata.transactionId, attachmentId: this.attachment?.id ?? this.metadata?.transactionId })
    }
  },
  beforeDestroy () {
    this.$store.dispatch('resetVideoStatus', this.attachment?.id ?? this.metadata?.transactionId)
  },
  computed: {
    sources: function () {
      return [{
        src: this.metadata.hls_url,
        type: 'application/x-mpegURL'
      }]
    },
    metadata: function () {
      return this.attachment.metadata ? this.attachment.metadata : {}
    },
    attachmentOrTransactionId: function () {
      return this.attachment?.id ?? this.metadata?.transactionId
    },
    videoProcessed: function () {
      return this.metadata.processingCompleted === true || this.metadata.processingComplete === true
    },
    videoStatus: function () {
      return this.$store.getters.getAttachmentVideoProcessStatus(this.attachmentOrTransactionId)
    },
    videoProgress: function () {
      return this.$store.getters.getAttachmentVideoProcessPercentage(this.attachmentOrTransactionId)
    },
    showPlayer: function () {
      if (this.videoProcessed) {
        return true
      } else {
        return !this.$store.getters.isAttachmentVideoProcessing(this.attachmentOrTransactionId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .columns {
    max-width: 100%;
    padding: 0.5rem;
    height: 100%;
    align-items: center;
  }

  .icon {
    display: block;
  }

  .media-content {
    margin-left: 1rem;
    p {
      padding-bottom: 0.6rem;
    }
  }

  .file{
    cursor: pointer;
    margin: 4rem 3rem;
  }

  .title {
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1.5rem;
  }
  .progress-text {
    margin: 1rem 0.25rem 0;
    padding: 0 4rem;
    text-align: center;
  }
  .progress-wrapper {
    height: 100%;
    align-items: center;
    div {
      text-align: center;
      color: white;
      font-weight: 700;
      background-color: #cecece;
      padding: 2rem;
      margin: 0 auto;
      border-radius: 5px;
    }
  }
</style>
